import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/20 to-transparent" data-id="element-889" data-mp="gzwdjbv1jimu" />

      <section className="section-padding bg-dark-bg relative overflow-hidden" data-id="element-890" data-mp="c2mqu3z1dl2p">
        {/* Subtle Ambient Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple/10 rounded-full blur-[150px] opacity-40 pointer-events-none" data-id="element-891" data-mp="81krln54d90q" />

        <div className="inner-container max-w-4xl relative z-10" data-id="element-892" data-mp="zs8p8p7l3w9n">
          <div className="mb-12" data-id="element-893" data-mp="vpc1yl73nbzd">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-894" data-mp="voj5cd1uu2uy">
              The Origin
            </span>
          </div>

          <div className="space-y-10 text-lg md:text-xl text-steel leading-relaxed font-inter" data-id="element-895" data-mp="3gft8vz26yddl">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-896" data-mp="3bgq66l9ooj8s">
              David lost $284k. He had investors walk away. He suffered the
              health consequences of working non-stop, carrying the weight of an
              entire operation on his shoulders.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} data-id="element-897" data-mp="15gyc5anhqzfg">
              The sleepless nights. The racing mind. The endless cycle of
              telling a team what to do, only to realize three weeks later that
              nothing was done.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="my-16 pl-8 border-l-4 border-transparent relative" data-id="element-898" data-mp="2t6conn4ghwvd">
              <div className="absolute left-[-4px] top-0 bottom-0 w-1 bg-gradient-to-b from-purple to-teal" data-id="element-899" data-mp="3c4nvm87zhpb8" />
              <div className="absolute inset-0 bg-purple/5 blur-xl -z-10" data-id="element-900" data-mp="381r7y33l730f" />
              <p className="font-poppins font-bold text-3xl md:text-4xl text-white italic leading-tight" data-id="element-901" data-mp="3337ktzd9bl6h">
                "I didn't build this from a business school theory. I built it
                because I lived the nightmare you're living."
              </p>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} data-id="element-902" data-mp="1mpr6cf39t220">
              Every hardship became the exact answer key to every client's
              problem. Like{' '}
              <span className="text-white font-medium" data-id="element-903" data-mp="1vdv5q0ckhrjj">
                Slumdog Millionaire
              </span>{' '}
              — everything David went through was exactly the answer to every
              question business owners are asking today.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} data-id="element-904" data-mp="2aacdkhljso1c">
              MindStream.ing wasn't built to be just another software tool. It
              was built to kill the devil in the details. It was built to give
              you back your sanctity, your family time, and your sleep.
            </motion.p>
          </div>
        </div>
      </section>
    </>;
}